export default {
  title: 'Neuigkeiten und Angebote via E-Mail erhalten',
  form: {
    marketing_subscription: {
      label: 'Erhalte exklusive Angebote, Rabatte und Updates direkt in dein Postfach',
    },
  },
};
